export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/pointRadial.js
// module id = ../../../../d3-shape/src/pointRadial.js
// module chunks = 4